module.exports = __webpack_public_path__ + "img/symbol_10_x100.c94f21d4.png";